import { Stack, Tabs, Tab, Chip } from '@mui/material';
import {
  HeaderBreadcrumbs,
  ScreenError,
  ScreenWrap,
  SoloLoading,
} from '../../components';
import { useParams, useLocation, Link, Navigate } from 'react-router';
import DailyTipsTab from './tabs/DailyTipsTab';
import WeeklyTasksTab from './tabs/WeeklyTasksTab';
import PsychologyPromptsTab from './tabs/PsychologyPromptsTab';
import ReflectionPointsTab from './tabs/ReflectionPointsTab';
import LessonsTab from './tabs/LessonsTab';
import { Api } from '../../api';
import { Model } from '../../models';

type PublishedCount =
  | 'publishedTips'
  | 'publishedTasks'
  | 'publishedPrompts'
  | 'publishedLessons'
  | 'publishedPoints';

export default function ProgramWeekScreen() {
  const { weekNumber, weekId } = useParams();
  const location = useLocation();

  const currentTab = location.pathname.split('/').pop();
  const isValidTab = Model.Program.TABS.some((tab) => tab.value === currentTab);

  if (!isValidTab && location.pathname === `/program/${weekNumber}/${weekId}`) {
    return (
      <Navigate to={`/program/${weekNumber}/${weekId}/daily-tips`} replace />
    );
  }

  const api = Api.ProgramWeek.useReadCollectionAdminList();
  if (api.error) return <ScreenError {...api} />;

  const week = api.data?.member?.find((w) => w.id === weekId);

  if (!week) return <SoloLoading />;

  return (
    <ScreenWrap>
      <Stack gap={3}>
        <HeaderBreadcrumbs
          title={`Week ${weekNumber}`}
          items={[
            { name: 'Program Content', url: '/program' },
            { name: week.program.title, url: `/program/${week.program.id}` },
          ]}
        />
        <Tabs
          value={currentTab || 'daily-tips'}
          sx={{ borderBottom: 1, borderColor: 'divider' }}
        >
          {Model.Program.TABS.map((tab) => (
            <Tab
              key={tab.value}
              value={tab.value}
              label={
                <Stack direction="row" alignItems="center" gap={1}>
                  {tab.label}
                  <Chip
                    label={week[tab.count as PublishedCount]}
                    size="small"
                    color="default"
                  />
                </Stack>
              }
              component={Link}
              to={`/program/${weekNumber}/${weekId}/${tab.value}`}
            />
          ))}
        </Tabs>
        {currentTab === 'daily-tips' && <DailyTipsTab />}
        {currentTab === 'weekly-tasks' && <WeeklyTasksTab />}
        {currentTab === 'psychology-prompts' && <PsychologyPromptsTab />}
        {currentTab === 'lessons' && <LessonsTab />}
        {currentTab === 'reflection-points' && <ReflectionPointsTab />}
      </Stack>
    </ScreenWrap>
  );
}
